// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3b1xJ","label":"styles_label__2W2RN"};